import React, { PropTypes } from "react";
import NumberFormat from "react-number-format";

const FormattedMetric = ({ dataType, value = "" }) => {
  let prefix = "";
  let suffix = "";
  if (value.toString().indexOf("-") > -1) {
    //  prefix += '-';
  } else {
    switch (dataType) {
      case "Currency":
        prefix += "$";
        break;
      case "Percentage":
        suffix += "%";
        break;
    }
  }

  return (
    <NumberFormat
      value={value}
      displayType={"text"}
      thousandSeparator
      prefix={prefix}
      suffix={suffix}
      allowNegative
    />
  );
};

FormattedMetric.propTypes = {
  dataType: PropTypes.string,
  value: React.PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.number
  ])
};

export default FormattedMetric;



// WEBPACK FOOTER //
// ./src/features/insights/components/FormattedMetric.js